import { Flex, HStack, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Portal, Text } from '@chakra-ui/react'
import { FaDeleteLeft } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'src/redux/hooks';
import { openDeleteModal } from 'src/redux/features/languages/languageSlice';
import { HamburgerIcon } from '@chakra-ui/icons';
import { useEffect, useState } from 'react';

type Props = {
  id: string
  code: string
}

const ActionTable = ({ id, code }: Props) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [isTranslating, setIsTranslating] = useState(false)

  const handleOpen = () => {
    dispatch(openDeleteModal(id))
  }

  useEffect(() => {
      const syncWithLocalStorage = () => {
        const isTranslating = localStorage.getItem("is-translating") ? true : false
        setIsTranslating(isTranslating)
      }
  
      // Handle changes in the same tab
      const interval = setInterval(syncWithLocalStorage, 1000)
  
      // Handle changes in other tabs
      const handleStorageChange = (event: StorageEvent) => {
        if (event.key === "is-translating") {
          syncWithLocalStorage()
        }
      }
      window.addEventListener("storage", handleStorageChange)
  
      // Cleanup on unmount
      return () => {
        clearInterval(interval)
        window.removeEventListener("storage", handleStorageChange)
      }
    }, [])

  return (
    <>
      {code !== "fr" ? (
        <Flex justifyContent='center' alignItems='center' h='100%' >
          <Menu>
            <MenuButton as={IconButton}
              isDisabled={isTranslating}
              aria-label='Options'
              icon={<HamburgerIcon />}
              variant='outline'
            />
            <Portal >
              <MenuList>
                <MenuItem>
                  <HStack w='100%' color='red.500' cursor='pointer' _hover={{ color: 'red.300' }} onClick={handleOpen} >
                    <Icon as={FaDeleteLeft} />
                    <Text>Suprimer</Text>
                  </HStack>
                </MenuItem>
                {/* <MenuItem >
              <HStack w='100%' color='blue.500' cursor='pointer' _hover={{color:'blue.300'}} onClick={goToProfile}>
                <Icon as={FaEdit}  />
                <Text>Modifier</Text>
              </HStack>
            </MenuItem> */}
              </MenuList>
            </Portal>
          </Menu>
        </Flex>
      ) : null}
    </>
  )
}

export default ActionTable